<template>
  <span v-for="(entries, index) in transactionString" :key="index" class="reorganize-tree-entries">
    <EntriesValue
      v-for="(entry, eIndex) in Array.isArray(entries) ? entries : []"
      :key="eIndex"
      :entry
    />
  </span>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue'

import { TransactionClass } from '@types'

import { TRANSACTION_FIELD } from '@/const'

import { getTransactionString } from '@/views/Data/Transactions/components/utils/helpers'

import { useTransactionsSettingsStore } from '@/store/transactions/settings'

import EntriesValue from './EntriesValue.vue'

type Props = {
  transaction: TransactionClass
}

const props = defineProps<Props>()

const transactionsSettingsStore = useTransactionsSettingsStore()

const getAssetName = inject('getAssetName', (id: string) => id)

const transactionsSettings = computed(() => transactionsSettingsStore.getList)
const type = computed(() => props.transaction.field<string>(TRANSACTION_FIELD.TYPE).value)

const transactionString = computed(() => {
  const typeSettings = transactionsSettings.value.find(item => item.name === type.value)
  if (!typeSettings) return ''
  return getTransactionString(props.transaction.get(), typeSettings, getAssetName)
})
</script>

<style scoped>
.reorganize-tree-entries {
  @apply flex flex-col sm:flex-row gap-1;
}
</style>
